(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4997],{

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66832);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57153);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11752);









var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_8__["default"])(), settings = ref.publicRuntimeConfig.settings;
var Banners = function(param) {
    var items = param.items;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref2[0], setPrevEl = ref2[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-auto",
        children: items && items.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                    className: "lg:rounded-br-2xl bg-red-brand",
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    pagination: {
                        clickable: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl
                    },
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
                    ],
                    children: items.map(function(item, index) {
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: item.link,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "flex justify-center",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "".concat(settings.cdn).concat(item.file),
                                        alt: ""
                                    })
                                })
                            })
                        }, index));
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "hidden md:flex absolute top-0 left-0 ml-8 h-full items-center ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-7 h-7 lg:w-8 lg:h-8 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10",
                        ref: function(node) {
                            return setPrevEl(node);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            direction: "left"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "hidden md:flex absolute top-0 right-0 mr-8 h-full items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-7 h-7 lg:w-8 lg:h-8 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10",
                        ref: function(node) {
                            return setNextEl(node);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            direction: "right"
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Banners);


/***/ }),

/***/ 86517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Filters_ActiveFilters; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Icons/CloseBold.js


var CloseBold = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height, _display = param.display, display = _display === void 0 ? "block" : _display;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        className: "fill-current ".concat(display),
        width: width,
        height: height,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.8995 1.12126C8.50897 0.730738 7.87581 0.730738 7.48528 1.12126L5.01041 3.59614L2.53554 1.12126C2.14501 0.730738 1.51185 0.730738 1.12132 1.12126C0.730799 1.51179 0.730799 2.14495 1.12132 2.53548L3.5962 5.01035L1.12132 7.48522C0.730799 7.87575 0.730799 8.50891 1.12132 8.89944C1.51185 9.28996 2.14501 9.28996 2.53554 8.89944L5.01041 6.42456L7.48528 8.89944C7.87581 9.28996 8.50897 9.28996 8.8995 8.89944C9.29002 8.50891 9.29002 7.87575 8.8995 7.48522L6.42462 5.01035L8.8995 2.53548C9.29002 2.14495 9.29002 1.51179 8.8995 1.12126Z",
            fill: ""
        })
    });
};
/* harmony default export */ var Icons_CloseBold = (CloseBold);

// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Filters/ActiveFilters.js





var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// Active-filter chips: yellow like before (George). Brico keeps the pill shape, altex/MG the square.
var CHIP_CLASS = isBricoStore ? "bg-filterYellow rounded-full px-2 inline-flex items-center justify-between mb-2" : "bg-filterYellow rounded-sm px-2 inline-flex items-center justify-between mb-2";
var ActiveFilters = function(param) {
    var activeFilters = param.activeFilters;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        className: "flex flex-wrap mt-4 lg:mt-0 md:mb-4 text-xs leading-[20px]",
        children: activeFilters.map(function(filter) {
            if (filter.removeAll) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: filter.removeUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: "Sterge tot",
                            className: "ml-2 text-sm text-red-brand hover:text-bleu-hover underline leading-18.2 -tracking-0.39",
                            onClick: function() {
                                (0,GTMHelper/* setGTMProductsFilterRemove */.bO)({
                                    removedFilters: filter,
                                    activeFilters: activeFilters
                                });
                            },
                            children: "sterge tot"
                        })
                    })
                }, filter.removeUrl));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    "data-filter": true,
                    "data-filtername": filter.label,
                    "data-filtervalue": filter.filter.slug,
                    className: "mr-3 md:mr-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: filter.removeUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            title: "Sterge",
                            className: CHIP_CLASS,
                            onClick: function() {
                                (0,GTMHelper/* setGTMProductsFilterRemove */.bO)({
                                    removedFilters: filter,
                                    activeFilters: activeFilters
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "capitalize pr-2",
                                    children: filter.slug === "price" ? filter.filter.slug : filter.filter.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CloseBold, {
                                    width: "9",
                                    height: "9"
                                })
                            ]
                        })
                    })
                }, "".concat(filter.slug, "-").concat(filter.filter.attributeSlug, "-").concat(filter.filter.slug)));
            }
        })
    });
};
/* harmony default export */ var Filters_ActiveFilters = (ActiveFilters);


/***/ }),

/***/ 68533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Filters_FilterGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/StarLabel.js
var StarLabel = __webpack_require__(80696);
;// CONCATENATED MODULE: ./components/Filters/CheckIcon.js

var CheckIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    className: "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M1.73 12.91l6.37 6.37L22.79 4.59"
    })
});
/* harmony default export */ var Filters_CheckIcon = (CheckIcon);

// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
;// CONCATENATED MODULE: ./components/Filters/FilterValues.js





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FilterValues = function(param) {
    var filters = param.filters, activeSlugs = param.activeSlugs, parentSlug = param.parentSlug, isModal = param.isModal, filterValueMobileClick = param.filterValueMobileClick, isReview = param.isReview, activeFilters = param.activeFilters;
    return filters.map(function(filter, i) {
        var filterLabelName = filter.label;
        if (parentSlug === "price") {
            filterLabelName = filter.slug;
            try {
                if (filters && filters.length > 1) {
                    if (i === 0) {
                        filterLabelName = "Sub ".concat(filterLabelName.split("-")[1]);
                    }
                    if (i === filters.length - 1) {
                        filterLabelName = "Peste ".concat(filterLabelName.split("-")[0]);
                    }
                }
                filterLabelName = filterLabelName.replace("-", " - ");
            } catch (e) {
                filterLabelName = filter.slug;
            }
        }
        var isActive = activeSlugs.includes("".concat(filter.attributeSlug || parentSlug, "-").concat(filter.slug));
        if (isModal) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "border-b border-gray-400",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "text-14px flex items-center w-full",
                onClick: function() {
                    return filterValueMobileClick(filter);
                },
                style: {
                    height: 48
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "checkbox-control inline-block align-top w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(isActive ? "checked" : ""),
                        children: Filters_CheckIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 w-full flex justify-between",
                        style: {
                            maxWidth: "calc(100% - 30px)",
                            marginTop: "1px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarLabel/* default */.Z, {
                                    value: filter.value[0]
                                }) : filterLabelName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "ml-1 text-gray-text",
                                children: [
                                    "(",
                                    filter.count,
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            })
        }, "".concat(parentSlug, "-").concat(filter.attributeSlug, "-").concat(filter.slug)));
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "mb-4 md:md-3 text-sm leading-snug lg:mr-3 ie-more-space block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: isActive ? filter.removeUrl : filter.addUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "flex items-center capitalize leading-18.2 -tracking-0.39 ".concat(isActive ? "is-active" : ""),
                    onClick: function() {
                        return isActive ? (0,GTMHelper/* setGTMProductsFilterRemove */.bO)({
                            removedFilters: filter,
                            activeFilters: activeFilters
                        }) : (0,GTMHelper/* setGTMProductsFilterApply */.xr)({
                            addedFilters: _objectSpread({}, filter, {
                                parentSlug: parentSlug
                            }),
                            activeFilters: activeFilters
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "checkbox-control inline-block align-top w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(isActive ? "checked" : ""),
                            children: Filters_CheckIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "flex",
                            style: {
                                maxWidth: "calc(100% - 30px)",
                                marginTop: "1px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: isReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarLabel/* default */.Z, {
                                        value: filter.value[0]
                                    }) : filterLabelName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "".concat(isReview ? "mb-1" : "", " ml-1 text-gray-text"),
                                    children: [
                                        "(",
                                        filter.count,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        }, "".concat(parentSlug, "-").concat(filter.attributeSlug, "-").concat(filter.slug)));
    });
};
/* harmony default export */ var Filters_FilterValues = (FilterValues);

// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Filters/FilterGroup.js











function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function FilterGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FilterGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilterGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// Filter footer buttons: bricostore uses the pill button system; altex/MG keep the yellow style.
var FILTER_APPLY_CLASS = isBricoStore ? "py-2 px-5 text-14px text-center w-full text-white bg-red-brand rounded-full" : "py-2 px-5 text-14px border-2 border-transparent bg-filterYellow w-full rounded-bl-lg rounded-tr-lg";
var FILTER_RESET_CLASS = isBricoStore ? "py-2 px-5 text-14px text-center w-full bg-red-soft border border-red-brand text-red-brand rounded-full" : "py-2 px-5 text-14px border-2 border-filterYellow w-full rounded-bl-lg rounded-tr-lg";
var FilterGroup = function(param) {
    var filter = param.filter, isModal = param.isModal, onFilterMobileApply = param.onFilterMobileApply, isLast = param.isLast, addModal1 = param.addModal, removeModal1 = param.removeModal, activeFilters = param.activeFilters;
    var isGeneral = filter.attribute_code === "general";
    var isReview = filter.attribute_code === "reviews_rating";
    // search input text
    var ref3 = (0,react.useState)(""), searchTerm = ref3[0], setSearchTerm = ref3[1];
    // values filtered by search
    var ref1 = (0,react.useState)(_toConsumableArray(filter.filters)), filterValues = ref1[0], setFilterValues = ref1[1];
    var hasSearch = filter.filters.length > 7;
    var initialActiveSlugs = _toConsumableArray(filter.filters).filter(function(el) {
        return el.isActive;
    }).map(function(el) {
        return "".concat(el.attributeSlug || filter.slug, "-").concat(el.slug);
    });
    // we keep a state of active values as we need it on mobile without modifying the original data
    var ref2 = (0,react.useState)(initialActiveSlugs), activeSlugs = ref2[0], setActiveSlugs = ref2[1];
    var activeLength = activeSlugs.length;
    var sameActive = isEqual_default()(sortBy_default()(initialActiveSlugs), sortBy_default()(activeSlugs));
    var filterValueMobileClick = function(filterValue) {
        var newActiveSlugs = _toConsumableArray(activeSlugs);
        var slugKey = "".concat(filterValue.attributeSlug || filter.slug, "-").concat(filterValue.slug);
        var activeIndex = newActiveSlugs.indexOf(slugKey);
        if (activeIndex > -1) {
            newActiveSlugs.splice(activeIndex, 1);
        } else {
            newActiveSlugs.push(slugKey);
        }
        setActiveSlugs(newActiveSlugs);
    };
    var generalSlugs = filter.slug === "general" ? filter.filters.map(function(filterValue) {
        return filterValue.attributeSlug;
    }) : null;
    var applyFilters = function() {
        var filters = filter.filters.filter(function(el) {
            return activeSlugs.includes("".concat(el.attributeSlug || filter.slug, "-").concat(el.slug));
        });
        onFilterMobileApply(generalSlugs ? null : filter.slug, FilterGroup_objectSpread({}, filter, {
            filters: filters
        }), generalSlugs);
    };
    var deleteAllFilters = function() {
        onFilterMobileApply(generalSlugs ? null : filter.slug, FilterGroup_objectSpread({}, filter, {
            filters: []
        }), generalSlugs);
    };
    (0,react.useEffect)(function() {
        if (searchTerm.length > 0) {
            var newValues = filter.filters.filter(function(el) {
                return el.label.toLowerCase().includes(searchTerm.toLowerCase());
            });
            setFilterValues(newValues);
        } else {
            setFilterValues(_toConsumableArray(filter.filters));
        }
    }, [
        searchTerm,
        filter.filters
    ]);
    if (isModal) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "border-b border-gray-400",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: function() {
                return addModal1("filter-group-".concat(filter.slug));
            },
            className: "text-left flex flex-col justify-center w-full",
            style: {
                height: 48
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("text-14px", {
                        "font-bold text-red-brand bd-claim": isBricoStore
                    }),
                    children: isGeneral ? "Disponibilitate" : isReview ? "Nota minima" : filter.label
                }),
                activeLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-12px text-red-brand",
                    children: activeLength === 1 ? "1 filtru selectat" : "".concat(activeLength, " filtre selectate")
                })
            ]
        })
    }, "".concat(filter.slug)));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("mb-2 leading-22 -tracking-0.22", {
                    "font-medium": !isBricoStore,
                    "font-bold text-red-brand bd-claim": isBricoStore
                }),
                children: isGeneral ? "Disponibilitate" : isReview ? "Nota minima" : filter.label
            }),
            hasSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white border-b border-gray-400 pb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                    className: "block",
                    meta: {},
                    input: {
                        onChange: function(e) {
                            return setSearchTerm(e.target.value);
                        },
                        value: searchTerm
                    },
                    placeholder: "Filtreaza"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "".concat(hasSearch ? "overflow-y-auto pt-4 border-b border-gray-400" : "", " ").concat(isLast ? "" : "mb-8"),
                style: {
                    height: hasSearch ? 278 : "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_FilterValues, {
                    isReview: isReview,
                    filters: filterValues,
                    activeSlugs: initialActiveSlugs,
                    parentSlug: filter.slug,
                    isModal: false,
                    filterValueMobileClick: filterValueMobileClick,
                    activeFilters: activeFilters
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                id: "filter-group-".concat(filter.slug),
                header: filter.label,
                onBack: function() {
                    return addModal1("filters");
                },
                hasStickyHeader: true,
                hasStickyFooter: true,
                onRemoveModal: function() {
                    // delay for the modal to actually close
                    setTimeout(function() {
                        setActiveSlugs(initialActiveSlugs);
                        setSearchTerm("");
                    }, 100);
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: !sameActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: FILTER_APPLY_CLASS,
                                onClick: function() {
                                    return applyFilters();
                                },
                                children: "Aplica filtrele"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: FILTER_RESET_CLASS,
                                onClick: function() {
                                    return deleteAllFilters();
                                },
                                children: "Sterge tot"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            activeLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: FILTER_RESET_CLASS,
                                onClick: function() {
                                    return deleteAllFilters();
                                },
                                children: "Sterge tot"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: FILTER_RESET_CLASS,
                                onClick: function() {
                                    return removeModal1();
                                },
                                children: "Inchide"
                            })
                        ]
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pt-16",
                    children: [
                        hasSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bg-white top-0 left-0 right-0 border-b border-gray-400 p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                className: "w-full",
                                meta: {},
                                input: {
                                    onChange: function(e) {
                                        return setSearchTerm(e.target.value);
                                    },
                                    value: searchTerm
                                },
                                placeholder: "Filtreaza"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "".concat(isLast ? "" : "mb-8"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_FilterValues, {
                                isReview: isReview,
                                filters: filterValues,
                                activeSlugs: activeSlugs,
                                parentSlug: filter.slug,
                                isModal: true,
                                filterValueMobileClick: filterValueMobileClick,
                                activeFilters: activeFilters
                            })
                        })
                    ]
                })
            })
        ]
    }, "".concat(filter.slug)));
};
/* harmony default export */ var Filters_FilterGroup = ((0,es/* connect */.$j)(null, {
    removeModal: actions/* removeModal */.a_,
    addModal: actions/* addModal */.Y_
})(FilterGroup));


/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 78880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PaginationWithLinks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/PaginationWithLinks/DirectionalButtonWrapper.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// replace (not append) the radius: bricostore prev/next are pills, altex/MG keep rounded-md
var pageRadius = isBricoStore ? "rounded-full" : "rounded-md";
var DirectionalButtonWrapper = function(param) {
    var url = param.url, children = param.children;
    if (url) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "inline-block py-1 px-2 mx-0.5 sm:mx-1 text-sm border border-gray-1100 ".concat(pageRadius, " items-center text-center bg-white"),
                children: children
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-gray inline-block py-1 px-2 mx-0.5 sm:mx-1 text-sm border border-gray-1100 ".concat(pageRadius, " items-center text-center bg-white"),
        children: children
    }));
};
/* harmony default export */ var PaginationWithLinks_DirectionalButtonWrapper = (DirectionalButtonWrapper);

;// CONCATENATED MODULE: ./components/PaginationWithLinks/ButtonWrapper.js



var ButtonWrapper_ref = (0,config["default"])(), ButtonWrapper_publicRuntimeConfig = ButtonWrapper_ref.publicRuntimeConfig, ButtonWrapper_websiteName = ButtonWrapper_publicRuntimeConfig.settings.websiteName;
var ButtonWrapper_isBricoStore = ButtonWrapper_websiteName === "bricostore";
// bricostore-only pagination overrides (circular shape + red active border); altex/MG untouched
// replace (not append) the radius so there's a single rounded-* class → no cascade conflict
var ButtonWrapper_pageRadius = ButtonWrapper_isBricoStore ? "rounded-full" : "rounded-md";
var activePageClass = ButtonWrapper_isBricoStore ? "bg-red-brand text-white border-red-brand" : "bg-alertRed text-white";
var ButtonWrapper = function(param) {
    var url = param.url, isActive = param.isActive, children = param.children;
    if (url && !isActive) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "mx-0.5 sm:mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ".concat(ButtonWrapper_pageRadius, " bg-white"),
                children: children
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-0.5 sm:mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ".concat(ButtonWrapper_pageRadius, " ").concat(isActive ? activePageClass : "text-gray"),
        children: children
    }));
};
/* harmony default export */ var PaginationWithLinks_ButtonWrapper = (ButtonWrapper);

// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/PaginationWithLinks/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PaginationWithLinks = function(param) {
    var _pagination = param.pagination, pagination = _pagination === void 0 ? [] : _pagination;
    var paginationCopy = pagination.map(function(p) {
        return _objectSpread({}, p);
    });
    var activeInitialIndex = paginationCopy.findIndex(function(e) {
        return e.active;
    });
    var defaultIndex = paginationCopy.findIndex(function(e) {
        return e.default;
    });
    var activeIndex = activeInitialIndex > -1 ? activeInitialIndex : defaultIndex > -1 ? defaultIndex : 0;
    // we need paginationCopy because after interval the activeIndex is no longer valid
    paginationCopy[activeIndex].active = true;
    var paginationWithInterval = (0,helpers/* getPaginationInterval */.CR)(paginationCopy, activeIndex);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "flex flex-wrap items-center py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationWithLinks_DirectionalButtonWrapper, {
                url: activeIndex > 0 ? paginationCopy[activeIndex - 1].url : null,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:inline-block",
                        children: "Pagina anterioara"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Toolbar-previous md:hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: "flex list-none m-0 p-0",
                children: paginationWithInterval.map(function(page, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: (parseInt(page.name) <= 20 || page.name === "...") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationWithLinks_ButtonWrapper, {
                                url: page.url,
                                isActive: page.active,
                                children: page.name
                            })
                        }, "".concat(page.name, "-").concat(i))
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationWithLinks_DirectionalButtonWrapper, {
                url: activeIndex < paginationCopy.length - 1 ? paginationCopy[activeIndex + 1].url : null,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:inline-block",
                        children: "Pagina urmatoare"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Toolbar-next md:hidden"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_PaginationWithLinks = (PaginationWithLinks);


/***/ })

}]);